module.exports = __webpack_public_path__ + "img/GALERIA-CIAZ-2021-2.49ebf088.jpg";